export const SMS_TEMPLATE_CREATE = 'SMS_TEMPLATE_CREATE'
export const SMS_TEMPLATE_CREATE_SUCCESS = 'SMS_TEMPLATE_CREATE_SUCCESS'
export const SMS_TEMPLATE_CREATE_FAILED = 'SMS_TEMPLATE_CREATE_FAILED'

export const SMS_TEMPLATE_DELETE = 'SMS_TEMPLATE_DELETE'
export const SMS_TEMPLATE_DELETE_SUCCESS = 'SMS_TEMPLATE_DELETE_SUCCESS'
export const SMS_TEMPLATE_DELETE_FAILED = 'SMS_TEMPLATE_DELETE_FAILED'

export const SMS_TEMPLATE_UPDATE = 'SMS_TEMPLATE_UPDATE'
export const SMS_TEMPLATE_UPDATE_SUCCESS = 'SMS_TEMPLATE_UPDATE_SUCCESS'
export const SMS_TEMPLATE_UPDATE_FAILED = 'SMS_TEMPLATE_UPDATE_FAILED'

export const SMS_TEMPLATE_RESET = 'SMS_TEMPLATE_RESET'

export const SMS_TEMPLATE_SEND = 'SMS_TEMPLATE_SEND'
export const SMS_TEMPLATE_SEND_SUCCESS = 'SMS_TEMPLATE_SEND_SUCCESS'
export const SMS_TEMPLATE_SEND_FAILED = 'SMS_TEMPLATE_SEND_FAILED'

export const SMS_TEMPLATE_FETCH = 'SMS_TEMPLATE_FETCH'
export const SMS_TEMPLATE_FETCH_SUCCESS = 'SMS_TEMPLATE_FETCH_SUCCESS'
export const SMS_TEMPLATE_FETCH_FAILED = 'SMS_TEMPLATE_FETCH_FAILED'

export const SET_SMS_TEMPLATES_ORDER = 'SET_SMS_TEMPLATES_ORDER'
